import creator from "./creator";
import select from "./select";

export default function(name) {
  return select(creator(name).call(document.documentElement));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/create.js
// module id = 2189
// module chunks = 2